<script>
	import Multiselect from "vue-multiselect";
	export default{
		components: { Multiselect },
		data(){
			return{
				id: '',
				search: '',
				currentPage: 1,
				order: 'desc',
      			sortby: 'id',
      			limit: 0,
				limits: [
		        {value: 25, text: "25"},
		        {value: 50, text: "50"},
		        {value: 100, text: "100"},
		    	],
				response_error: []
			}
		},
		props: {
			isDisabled: {
				type: Boolean,
				default: () => false,
				},
			options: {
				type: Array,
				default: () => [],
				},
			data_provided: {
				type: Boolean,
				default: () => false
				}
		},
		mounted(){
			if(this.data_provided == false){
				axios.get('/api/company/listings?page='+this.currentPage+'&limit='+this.limit+'&sortby='+this.sortby+'&order='+this.order+'&search='+this.search+'', {headers: {'Authorization' : 'Bearer '+this.$attrs.api_token}}).then(response => {
					this.options = response.data.data;
				}).catch(error => {
					this.response_error = error.data;
				});
			}
			this.id = this.$attrs.id;
			
		},
		methods:{
			updateDepartment: function(selectedOption, id){
				this.$emit('listing-selected', selectedOption);
			},
			customLabel ({ title, desc }) {
		      return `${title} – ${desc}`
		    }
		}
	}
</script>
<template>
	<div>
	<multiselect v-model="id" track-by="name" label="name" :options="options" @select="updateDepartment" :option-height="104" :disabled="isDisabled" placeholder="Select Customer Address..." >
                     <!--<template slot="singleLabel" slot-scope="{ option }">{{ option.name }} - {{ option.jobtitle }}</template>-->
                     <template slot="singleLabel" slot-scope="{ option }"><div class="d-flex w-100 h-100"><div class="avatar-sm mr-4 my-auto">
                        <span class="avatar-title rounded-circle">{{(option.address_1).slice(0,1)}}</span>
                      </div>
      <div class="option__desc d-flex flex-row w-75"><span class="option__title ml-2 my-auto w-100">{{ option.address_1 }}<br><p class="m-0 lh-1 w-100 text-truncate"><small>{{ option.address_2}} {{ option.address_3}} {{ option.city}} <span v-if="option.county">{{option.county.name}}</span> <span v-if="option.country">{{option.country.name}}</span> {{option.postcode}}</small></p></span>
      </div>
  		</div></template>
    <template slot="option" slot-scope="{ option }">
    	<div class="d-flex"><div class="avatar-sm mr-4">
                        <span class="avatar-title rounded-circle">{{(option.address_1).slice(0,1)}}</span>
                      </div>
      <div class="option__desc d-flex flex-row w-50"><span class="option__title ml-2 my-auto w-100">{{ option.address_1 }}<br><p class="m-0 lh-1 w-100 text-truncate"><small>{{ option.address_2}} {{ option.address_3}} {{ option.city}} <span v-if="option.county">{{option.county.name}}</span> <span v-if="option.country">{{option.country.name}}</span> {{option.postcode}}</small></p></span>
      </div>
  		</div>
    </template>
    <template slot="noOptions"></slot>
    	<div class="w-100 d-flex p-4 justify-content-center align-items-center bg-light flex-column border-radius-1em">
    		<i class="bx bx-home-alt font-size-42"></i>
    		<span>No Addresses to Show</span>
    		<a class="btn btn-primary btn-rounded mt-3" @click="$emit('add-address')">Add New Address</a>
    	</div>
    	
    </template>
    <template slot="afterList"></slot>
    	<div class="w-100 d-flex p-2 justify-content-center align-items-center bg-light flex-column border-radius-1em">
    		<a class="btn btn-primary btn-block btn-rounded mt-3" @click="$emit('add-address')">Add New Address</a>
    	</div>
    	
    </template>
                  </multiselect>
   </div>
</template>